import { createReducer } from "../../../common/reduxUtil";
import {
  GMAT_SET_TOUR,
  GMAT_SET_TOUR_BUSY,
  GMAT_SET_TOUR_ERROR,
  GMAT_SET_TOUR_COMPLETION,
  GMAT_RESET_TOUR,
} from "./types";

const initialState = {
  tour: null,
  isBusy: false,
  error: "",
  completion: null,
};

export default createReducer(initialState, {
  // An older revision of the same tour (a slow response) never replaces a newer one.
  [GMAT_SET_TOUR]: (state, tour) =>
    state.tour?.id === tour.id &&
    (state.tour?.revision || 0) > (tour.revision || 0)
      ? state
      : { ...state, tour },
  [GMAT_SET_TOUR_BUSY]: (state, isBusy) => ({ ...state, isBusy }),
  [GMAT_SET_TOUR_ERROR]: (state, error) => ({ ...state, error }),
  [GMAT_SET_TOUR_COMPLETION]: (state, completion) => ({
    ...state,
    completion,
  }),
  [GMAT_RESET_TOUR]: () => initialState,
});
